<template>
  <div class="coursesHomePage">
    <div class="courseNav">
      <div class="courseinner">
        <span class="bar"></span>
        <h2>{{ $t("nav__courses") }}</h2>
      </div>
      <button>{{ $t("standard") }}</button>
      <!-- <button>{{$t('bootcamp')}}</button> -->
      <!-- <select name="" id="">
        <option value="">{{ $t("web_dasturlash") }}</option>
        <option value="">Grafik Dizayn</option>
        <option value="">It Kids</option>
      </select> -->
    </div>
    <div class="coursesWrapper">
      <div
        clas
        v-for="(course, index) in courses"
        :key="index"
        class="course-card"
        @click="goToCourse(course.navigate)"
      >
        <!-- <a :href="course.navigate"> -->
        <div class="course-image">
          <img
            loading="lazy"
            v-if="course.image"
            :src="course.image"
            alt="Course Image"
          />
          <!-- <course_img name="coursedefimg"/> -->
        </div>
        <div class="course-info">
          <h3>{{ course.title }}</h3>
          <p>{{$t("Davomiyligi")}} - {{ course.duration }} {{ $t("month") }}</p>
          <div class="course-buttons">
            <!-- <button class="btn-primary">Dasturlash</button> -->
            <!-- <button class="btn-secondary">O'rganish</button> -->
            <button class="btn-secondary">{{$t("yozilish")}}</button>
          </div>
        </div>
        <!-- </a> -->
      </div>
    </div>
  </div>
</template>

<script>
import course_img from "@/components/Template/Icons.vue";

export default {
  components: {
    course_img,
  },
  data() {
    return {
      courses: [
        {
          title: "Frontend",
          duration: "9",
          image: require("@/assets/Images/students/frontend.jpg"),
          navigate: "https://kurslar.algoritmedu.uz/web",
        },
        {
          title: "Backend: Node JS",
          duration: "3",
          image: require("@/assets/Images/students/backend.jpg"),
          navigate: "https://kurslar.algoritmedu.uz/",
        },
        {
          title: "Graphic Design",
          duration: "6",
          image: require("@/assets/Images/students/kids.jpg"),
          navigate: "https://kurslar.algoritmedu.uz/",
        },
        {
          title: "SMM  ",
          duration: "4",
          image: require("@/assets/Images/students/smm.jpg"),
          navigate: "https://kurslar.algoritmedu.uz/smm",
        },
        {
          title: "Kiberxavfsizlik  ",
          duration: "10",
          image: require("@/assets/Images/students/frontend.jpg"),
          navigate: "https://kurslar.algoritmedu.uz/",
        },
        {
          title: "IT kids  ",
          duration: "10",
          image: require("@/assets/Images/students/childs.jpg"),
          navigate: "https://kurslar.algoritmedu.uz/",
        },
      ],
    };
  },
  methods: {
    goToCourse(url) {
      window.location.href = url;
    },
    
  },
 
};
</script>

<style>
.coursesHomePage {
  margin-top: 45px;
  height: auto;
}

.courseNav {
  width: 100%;
  display: flex;
  padding-left: 17px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.courseinner {
  display: flex;
  gap: 10px;
  align-items: center;
  color: #0d0d0d;
}
.courseinner .bar {
  width: 4px;
  height: 43px;
  background: yellow;
  margin-right: 10px;
  border-radius: 3px;
}
.courseNav button:nth-of-type(1) {
  font-size: 21px;
  background-color: #fff;
  border-radius: 10px;
  font-weight: 500;
  padding: 9px 21px;
  max-height: 47px;
}
.courseNav button:nth-of-type(2) {
  font-size: 21px;
  color: #fff;
  border-radius: 10px;
  background-color: #0d0d0d;
  font-weight: 500;
  padding: 9px 21px;
  max-height: 47px;
}

.courseNav select {
  font-size: 21px;
  background-color: #fff;
  border-radius: 10px;
  font-weight: 500;
  padding: 8px 21px;
  max-height: 47px;
  color: #0d0d0d;

}
.courseinner h2 {
  font-size: 36px;
  color: #fff;
}

.courseNav button {
  padding: 5px;
  background: #efed40;
  color: #0d0d0d;
}

.coursesWrapper {
  display: flex;
  display: grid;
  grid-template-columns: auto auto;
  height: auto;
  /* gap: 25px; */
  row-gap: 30px;
  justify-content: space-between;
  margin-top: 30px;
}

.course-card {
  width: 100%;
  max-width: 615px;
  background: black;
  color: white;
  /* padding: 15px; */
  border-radius: 10px;
  border: 2px solid transparent;
  cursor: pointer;
  display: flex;
  gap: 20px;
  justify-content: start;
  transition: all 0.3s;
}
/* 
.course-card.selected {
  border-color: rgb(255, 255, 255);
} */

.course-image {
  width: 285px;
  height: 200px;
  background: rgba(13, 13, 13, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
}
.course-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* border-radius: 10px; */
}
.course-info {
  min-width: 320px;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  flex-direction: column;
}
.course-info h3 {
  font-size: 32px;
  margin-top: 10px;
  font-weight: 500;
}
.course-info p {
  font-size: 20px;
  font-weight: 400;
  margin-top: 8px;
}

.course-buttons {
  display: flex;
  gap: 10px;
  margin-top: 23px;
}

.btn-primary {
  background: #0d0d0d;
  color: white;
  padding: 5px 17px;
  max-height: 31px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
}

.btn-secondary {
  background: #fff;
  color: black;
  padding: 5px 17px;
  max-height: 31px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
}

@media (max-width: 1440px) {
  .courseinner h2 {
    width: 49%;
    text-align: start;
  }
   /* .coursesWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  } */
   .course-image{
    width: 200px;
   }
   .course-info{
    /* width: max-content; */
    min-width: 0;
   }
   .course-info h3 {
      font-size: 32px;
      margin-top: 10px;
      font-weight: 500;
    }
    .course-info p {
      font-size: 20px;
      font-weight: 400;
      margin-top: 8px;
    }

}
@media(max-width:1300px){
  .course-card{
    flex-direction: column;
    width: 380px;
  }
  .course-image{
    width: 100%;
  }
  .coursesWrapper{
    justify-content: space-around;
    align-items: center;
  }
  .course-info{
    width: 100%;
  }
}
/* @media(max-width:1000px){
  .course-card{
    flex-direction: column;
  }
  .course-image{
    width: 80%;
  }
} */
 @media(max-width: 950px){
    .course-card{
    flex-direction: column;
    width: 100%;
  }
  .coursesWrapper{
    gap: 20px;
    row-gap: 30px;
  }
 }
@media (max-width: 768px) {
  .courseNav {
    display: flex;
    justify-content: left;
    gap: 10px;
  }
  .course-card{
    flex-direction: column;
  }
  .coursesWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .course-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px;
    /* background: #383838e1; */
  }
  .course-image {
    width: 100%;
    height: 250px;
    object-fit: cover;
  }
  .courseinner button:nth-of-type(1) {
    font-size: 16px;
  }
  .courseNav button:nth-of-type(2) {
    font-size: 16px;
  }
}
@media (max-width: 500px) {
  .courseinner h2 {
    font-size: 24px;
  }
  .courseinner button:nth-of-type(1) {
    font-size: 14px;
  }
  .courseNav button:nth-of-type(1),.courseNav select{
    font-size: 14px;
  }
  .courseNav button:nth-of-type(2) {
    font-size: 14px;
  }
  .course-card {
    width: 100%;
    max-width: 100%;
    padding: 20px;
  }
  .course-info {
    width: 100%;
    max-width: 100%;
    min-width: auto;
  }
  .course-info h3 {
    font-size: 24px;
  }
}
</style>
